import {getLayoutData, getPageData} from "@/pages/api/api";
import {
	DESCRIPTION_WITH_IMAGE_QUERY,
	GLOBAL_BASED_BANNER_QUERY,
	SEE_ALSO_INFO_BLOCK_QUERY,
	SEO_QUERY
} from "@/pages/api/fragments";
import ExtendedContent from "@/components/common/ExtendedContent";
import useSetBannerData from "@/hooks/useSetBannerData";
import {CONTENT_TYPES} from "@/constants";
import SeeAlso, {getSeeAlsoData} from "@/components/SeeAlso";
import {useMemo} from "react";

export default function BeWithUs({data}) {
	const content = data?.content || []
	const bannerData = useSetBannerData(data)

	const seeAlsoInfo = data?.seeAlsoInfo || { header: '', variant: ''}
	const formattedSeeAlsoData = useMemo(() => getSeeAlsoData(data),[data])

	return (
		<>
			<ExtendedContent content={content} globalBannerData={bannerData}/>
			<SeeAlso
				header={seeAlsoInfo.header}
				variant={seeAlsoInfo.variant}
				data={formattedSeeAlsoData}
			/>
		</>
	)
}

const BE_WITH_US_PAGE_QUERY = `
	query GetBeWithUsPageData($locale: SiteLocale) {
		allBeWithUsPages(locale: $locale,  filter: {slug: {eq: "badz-z-nami"}}) {
			__typename
			pageName
			slug
			${SEO_QUERY}
			content {
				__typename
				${GLOBAL_BASED_BANNER_QUERY}
				${DESCRIPTION_WITH_IMAGE_QUERY}
			}
			seeAlsoInfo{
				${SEE_ALSO_INFO_BLOCK_QUERY}
			}
			seeAlsoLinks {
				__typename
				... on ${CONTENT_TYPES.SINGLE_PAGE} {
					__typename
					id
					pageType
					slug
					card {
						header
						description
					}
				}
				... on ${CONTENT_TYPES.SINGLE_BE_WITH_US_PAGE} {
					__typename
					id
					slug
					category {
						slug
						
					}
					card {
						header
						description
					}
				}
			}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData('allBeWithUsPages', 'badz-z-nami', BE_WITH_US_PAGE_QUERY, locale);
	const layout = await getLayoutData(locale)
	return {
		props: {
			data,
			locale,
			...layout,
			isDarkSearch: true,
			isBeWithUsCategory: true,
		},
		revalidate: 60 * 60
	};
}
